import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import { selectListItems } from '../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function SubscriptionBusinessInfoComponent ({handleInnerFormChange, subscriptionDetails}: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer

label="Business Name"
name="Business Name"
onValueChange={(event: any) => {
    handleInnerFormChange(
     event.target.value,
    'BusinessName'
  );
}}
type="text"
value={subscriptionDetails?.BusinessName}
/>
<InputContainer
                 isRequired
                 label="Business Type"
                 labelField="Description"
                 list={libraryData?.result?.BusinessType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                          'BusinessTypeId'
                       );
                 }}
                 optionName="Choose BusinessType"
                 type="select"
                 value={subscriptionDetails?.BusinessTypeId}
                 valueField="Value"
             />
 <InputContainer
                 isRequired
                 label="Industry Type"
                 labelField="Text"
                 list={libraryData?.result?.IndustryType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                          'IndustryTypeId'
                       );
                 }}
                 optionName="Choose IndustryType"
                 type="select"
                 value={subscriptionDetails?.IndustryTypeId}
                 valueField="Value"
             />
  </div>
  }
  expandedPanel="Business Info"
  headerTitle="Business Info"
/>


        </>
  )
}